import * as React from "react";
import { DataSearch, MultiDropdownList, DateRange, SelectedFilters } from "@appbaseio/reactivesearch";
import { componentIds } from "./utils";
import MomentLocaleUtils, { formatDate, parseDate } from "react-day-picker/moment";
import "../../../helperComponents/Elasticsearch/elasticsearch.scss";

var defaultQuery = function defaultQuery() {
  return {
    timeout: "10s",
    query: {
      match_all: {}
    },
    size: 1
  };
};

var SearchInputs = function SearchInputs() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement(DataSearch, {
    className: "col-md-4 elasticsearch-component",
    componentId: "endorsement_id",
    dataField: ["id_keyword", "poliza.asegurado.rut", "poliza.contratante.rut", "poliza.asegurado.full_name", "poliza.contratante.full_name", "poliza.code"],
    queryFormat: "and",
    fuzziness: 2,
    title: "N\xBA solicitud endoso, N\xBA p\xF3liza, Contratante/Asegurado",
    placeholder: "N\xBA solicitud endoso, N\xBA p\xF3liza, Contratante/Asegurado" // defaultQuery={defaultQuery}
    ,
    autosuggest: false // somehow it crashes with this
    ,
    react: {
      and: componentIds("endorsement_id")
    }
  }), /*#__PURE__*/React.createElement(MultiDropdownList, {
    className: "col-md-4 elasticsearch-component",
    defaultQuery: defaultQuery,
    componentId: "endorsement_status_name",
    dataField: "status_name.keyword",
    sortBy: "count",
    showCount: true,
    showMissing: true,
    showFilter: true,
    filterLabel: "Estado Endoso",
    title: "Estado Endoso",
    URLParams: false,
    loader: ".",
    react: {
      and: componentIds("endorsement_status_name")
    }
  }), /*#__PURE__*/React.createElement(MultiDropdownList, {
    className: "col-md-4 elasticsearch-component",
    defaultQuery: defaultQuery,
    componentId: "endorsement_type",
    dataField: "endorsement_type_translated.keyword",
    sortBy: "count",
    showCount: true,
    showMissing: true,
    showFilter: true,
    filterLabel: "Tipo Endoso",
    title: "Tipo Endoso",
    URLParams: false,
    loader: ".",
    react: {
      and: componentIds("endorsement_type")
    }
  }), /*#__PURE__*/React.createElement(MultiDropdownList, {
    className: "col-md-4 elasticsearch-component",
    defaultQuery: defaultQuery,
    componentId: "endorsement_created_by_email",
    dataField: "created_by_email.keyword",
    sortBy: "count",
    showCount: true,
    showMissing: true,
    showFilter: true,
    filterLabel: "Creado por",
    title: "Creado por",
    URLParams: false,
    loader: ".",
    react: {
      and: componentIds("endorsement_created_by_email")
    }
  }), /*#__PURE__*/React.createElement(DateRange, {
    componentId: "created_at",
    className: "col-md-4 elasticsearch-component",
    dataField: "created_at",
    title: "Fecha de creaci\xF3n",
    placeholder: {
      start: "Inicio",
      end: "Termino"
    },
    numberOfMonths: 2,
    queryFormat: "date",
    autoFocusEnd: true,
    showClear: true,
    showFilter: true,
    filterLabel: "Fecha",
    dayPickerInputProps: {
      formatDate: formatDate,
      parseDate: parseDate,
      format: "DD/MM/YYYY",
      placeholder: "".concat(formatDate(new Date(), "DD/MM/YYYY", "es")),
      dayPickerProps: {
        locale: "es",
        localeUtils: MomentLocaleUtils
      }
    },
    react: {
      and: componentIds()
    }
  }), /*#__PURE__*/React.createElement(DateRange, {
    className: "col-md-4 elasticsearch-component",
    componentId: "start_date",
    dataField: "start_date",
    title: "Fecha de inicio de vigencia",
    numberOfMonths: 2,
    autoFocusEnd: true,
    showClear: true,
    showFilter: true,
    filterLabel: "Fecha",
    queryFormat: "date",
    placeholder: {
      start: "Inicio",
      end: "Termino"
    },
    dayPickerInputProps: {
      formatDate: formatDate,
      parseDate: parseDate,
      format: "DD/MM/YYYY",
      placeholder: "".concat(formatDate(new Date(), "DD/MM/YYYY", "es")),
      dayPickerProps: {
        locale: "es",
        localeUtils: MomentLocaleUtils
      }
    },
    react: {
      and: componentIds()
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement(SelectedFilters, {
    className: "elasticsearch-component",
    showClearAll: true,
    clearAllLabel: "Limpiar filtros"
  })));
};

export default SearchInputs;